/* The v0 prototype's minimal footer (components/renter/simple-footer.tsx): copyright plus the
   Terms and Privacy links. Picks up the page's current theme tokens, so it is black at the end of
   the TNT page. */
export function SimpleFooter() {
  return (
    <footer className="bg-background">
      <div className="max-w-6xl mx-auto px-5 sm:px-6 py-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <p className="text-sm text-muted-foreground">© 2026 Rentid, Inc.</p>
        <nav className="flex items-center gap-6 text-sm" aria-label="Footer">
          <a href="/terms" className="text-muted-foreground hover:text-foreground transition-colors">
            Terms
          </a>
          <a href="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">
            Privacy
          </a>
        </nav>
      </div>
    </footer>
  );
}
